import { mergeDeep } from 'util';

class AccessibilityConfig {
    constructor() {
        this.config = {
            base: {
                readerPreferenceForEdge: 'jaws',
                disablePlotDetailsForIE: false
            }
        };
    }    

    setConfig(config, chartId, value) {

        if(config && value && typeof config === 'string') {
            if(chartId)
                this.config[chartId][config] = value;
            else
                this.config.base[config] = value;
        }
        else {
            if(chartId)
                this.config[chartId] = mergeDeep(this.config[chartId], config);
            else
                this.config.base = mergeDeep(this.config[base], config);
        }
        
    }

    getConfig(chartId) {
        if(this.config.hasOwnProperty(chartId))
            return mergeDeep(this.config[chartId], this.config.base);        

        return this.config.base;

    }
}

export default AccessibilityConfig;